import { initSentry, Sentry } from './lib/sentry';
initSentry();

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './stores/theme';
import './stores/locale';
import './lib/auth-reset';
import './styles/tailwind.css';
import i18next from './lib/i18n';
import { App } from './app';
import { captureDirectoryClaimFromUrl } from './lib/directory-claim';

captureDirectoryClaimFromUrl();

const root = document.getElementById('root');
if (!root) throw new Error('missing #root element');

createRoot(root).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ eventId }) => (
        <div className="grid min-h-screen place-items-center bg-bg px-6 text-center text-ink">
          <div className="max-w-sm">
            <h1 className="font-display text-2xl font-bold">{i18next.t('errorBoundary.title')}</h1>
            <p className="mt-2 text-sm text-muted">{i18next.t('errorBoundary.description')}</p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-4 bg-accent px-5 py-2 text-sm font-semibold text-on-accent"
            >
              {i18next.t('errorBoundary.reload')}
            </button>
            <p className="mt-4 font-mono text-xs text-muted">{eventId}</p>
          </div>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
